import { toSentenceCase } from "@visioni/a3s-ui/utils";
import { VEHICLE_TYPE_LABELS, type VehicleType } from "../constants";

/**
 * Formats a vehicle type string into its display label in sentence case.
 * Falls back to replacing underscores with spaces if the type is unknown.
 */
export function formatVehicleType(type: string): string {
  const label = VEHICLE_TYPE_LABELS[type as VehicleType];
  if (label) return toSentenceCase(label);

  return toSentenceCase(type.split("_").join(" "));
}
